// Declare global variables
const url = window.location.href
const urlLowercase = url.toLocaleLowerCase()
const formCtas = document.getElementById('form_ctas_identifier')

// Check if UTM is in URL
if (urlLowercase.includes(('utm'))) {
    
    // Explode the initial URL and assign variables
    const urlExploded = url.split("?")
    const queryExploded = urlExploded[1].split('#')
    const query = queryExploded[0]

    // Ensure formCtas element exists before proceeding
    if (formCtas) {

        // Find child elements of formCtas
        const children = formCtas.querySelectorAll('.form_ctas__cta')

        if (children) {
            // Loop through each child element
            children.forEach(child => {
                const link = child.href
    
                // Ensure that there is an Anchor within the URL before proceeding
                if (link.includes('#')) {
                    const linkExploded = link.split('#')
                    const linkExplodedUrl = linkExploded[0]
                    const linkExplodedAnchor = linkExploded[1]
    
                    // Concatenate the initial URL query between the site URL and the Anchor captured from each child
                    child.href = `${linkExplodedUrl}?${query}#${linkExplodedAnchor}`
                }
            });
        }
    }
}